















































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import UserType from '@/components/shared/UserType.vue'
import moment from 'moment-timezone'
import { getUserLocationText, getUserLonLatText } from '@/_utils/user'

import UserModel from '@/_models/UserModel'
import BeaconModel from '@/_models/BeaconModel'
import CardModel from '@/_models/CardModel'
import FloorModel from '@/_models/FloorModel'

@Component({
  components: {
    UserType,
  },
})
export default class TrackingHistory extends Vue {
  @Prop() data!: any
  @Prop() user!: UserModel

  fromTime = moment().subtract(1, 'hours').format('HH:mm')
  toTime = moment().format('HH:mm')
  isOpen = 0

  get beacons(): BeaconModel[] {
    return this.$store.state.beacons.all.items
  }

  get cards(): CardModel[] {
    return this.$store.state.cards.all.items
  }

  get floors(): FloorModel[] {
    return this.$store.state.floors.all.items
  }

  get filteredData() {
    return this.data
      .filter((item) => {
        const arrivedAt = this.formatToMinutes(new Date(item.atTime))
        const startMinutes = this.formatStringToMinutes(this.fromTime)
        let endMinutes = this.formatStringToMinutes(this.toTime)
        endMinutes = endMinutes === 0 ? 24 * 60 : endMinutes
        return startMinutes <= arrivedAt && arrivedAt <= endMinutes
      })
      .sort((a, b) => {
        return this.getDate(b.atTime) - this.getDate(a.atTime)
      })
  }

  formatToMinutes(date: Date) {
    return moment(date).minutes() + moment(date).hours() * 60
  }

  formatStringToMinutes(str: string) {
    return moment(str, 'HH:mm').minutes() + moment(str, 'HH:mm').hours() * 60
  }

  getDate(date: string) {
    return new Date(date).getTime()
  }

  getUserLocationText(user: UserModel): string {
    return getUserLocationText(user, this.beacons, this.cards) as string
  }

  getUserLonLatText(user: UserModel): string {
    return getUserLonLatText(user)
  }

  getFloorText(floorId: string) {
    return this.floors.find((floor) => floor._id === floorId)?.name || 'Outside'
  }

  getChangeInDoorText(userChange: any, isToLocation: boolean): string {
    const floor = this.floors.find((item: FloorModel) => item._id === userChange.floorId)
    const floorName = floor ? floor.name : 'Outside'
    if (isToLocation) {
      return this.getLocationName(userChange.toDeviceId, userChange.toDevice) + ', ' + floorName
    } else {
      return this.getLocationName(userChange.fromDeviceId, userChange.fromDevice) + ', ' + floorName
    }
  }

  getLocationName(valueFilter: string, deviceType: string): string {
    if (deviceType === 'card') {
      return this.cards.find((card) => card._id === valueFilter)?.location_name || ''
    }

    return this.beacons.find((beacon) => beacon._id === valueFilter)?.location_name || ''
  }
}
